module.exports = __webpack_public_path__ + "img/gift.911490f1.svg";